<div mat-dialog-title class="dialog-title">
    <button mat-icon-button aria-label="close dialog" mat-dialog-close style="float: right;bottom: 12px;">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div>
    <mat-carousel timings="250ms ease-in" [autoplay]="true" [interval]="interval" color="accent" proportion="25"
        [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="false"
        orientation="ltr">
        <mat-carousel-slide *ngFor="let slide of slides; let i = index;" [hideOverlay]="false">
            <div *ngIf="slide.mimeType.split('/')[0] === 'image'; else videoTemplate"> 
                <img [src]="slide.url" alt="Slide {{ i + 1 }}" style="width: 650px;height: 500px;object-fit: contain;" />
            </div>
            <ng-template #videoTemplate>
                <video [src]="slide.url" controls muted (play)="onVideoPlay(i)" (pause)="onVideoPause(i)"
                    (loadedmetadata)="setVideoDuration(i, $event)" style="width: 650px; height: 500px;object-fit: contain;">
                    Your browser does not support the video tag.
                </video>
            </ng-template>
        </mat-carousel-slide>
    </mat-carousel>
</div>